/** Раздел 1С, чьё окно открывается из карточки ресурса или вкладки раздела. */
export type OneCSourcePurpose = 'products' | 'supplies' | 'pricing' | 'inventory' | 'priceTags' | 'import' | 'structure' | 'receipts'

/**
 * Право, без которого окно раздела ничего не покажет (то же, что у входа из карточки ресурса и у вкладки раздела): право ГЛАВНОГО
 * чтения окна. Склады инвентаризации и ценников читаются справочником поставок (`supplies.read`) — второе право
 * `me/resources` отбирать не умеет (одно `capability`), его отказ окно показывает словами службы.
 */
export const ONEC_SOURCE_PURPOSES: Readonly<Record<OneCSourcePurpose, { capability: string }>> = {
  products: { capability: 'catalog.read' },
  supplies: { capability: 'supplies.read' },
  pricing: { capability: 'prices.read' },
  inventory: { capability: 'inventory.read' },
  // Ценник — скан штрихкода с ценой склада (`inventory/scan`, право inventory.read), а не чтение цен.
  priceTags: { capability: 'inventory.read' },
  import: { capability: 'import.read' },
  // ONEC-STRUCT: структура открыта по праву поставок или инвентаризации (отдельного права справочников в карте нет);
  // `me/resources` отбирает по одному праву — по главному, поставкам; отказ второго окно покажет словами службы.
  structure: { capability: 'supplies.read' },
  // RP-FB12: чеки ККМ и возвраты базы — своё право чтения.
  receipts: { capability: 'receipts.read' },
}
